import { oncallFetch } from "sc/backend/oncall/fetch-helper";

export default function*(email) {
  return yield oncallFetch(
    "/api/oncall/partners/contact-details/emails/remove",
    { email },
  );
}



// WEBPACK FOOTER //
// ./src/sc/backend/oncall/partners/contact-details/emails/remove.js